import { doRequest } from "utils/core";

const contactAPI = {
  postContactAuth: (data) => {
    const url = "api/contact/login";
    return doRequest("post", url, { data });
  },
  postContact: (data) => {
    const url = "api/contact/withoutlogin";
    return doRequest("post", url, { data });
  },
  getCMS: () => {
    const url = `api/terms/info`;
    return doRequest("get", url);
  },
};

export default contactAPI;
